import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const styles = theme => ({
  root: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.light,
    wordBreak: 'break-word',
    whiteSpace: 'nowrap',
    ...theme.typography.subtitle1,
    fontFamily: 'MadaBold',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#7e7e7e',
    fontSize: '0.95rem',
  },
});

export default withStyles(styles)(TableCell);
